module.exports = __webpack_public_path__ + "static/img/list-amaraGelFullFaceMask.eb5b817.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/list-amaraGelFullFaceMask.png
// module id = W5M8
// module chunks = 1